import { GAME_MODE, createInitialConnect4State } from "./connectFour";
import { buildLeaderboardAfterRound } from "./connect4Series";

export const MODE_STORAGE_KEY = "connect4SelectedMode";
export const MODE_CPU = "cpu";
export const MODE_MULTIPLAYER = "multiplayer";

export const CPU_SERIES_KEY = "connect4CpuSeries";
export const CPU_GAME_KEY = "connect4CpuGame";
export const CPU_OPPONENT_ID = "__cpu__";

export function getSelectedGameMode() {
  try {
    const v = String(
      sessionStorage.getItem(MODE_STORAGE_KEY) ||
        localStorage.getItem(MODE_STORAGE_KEY) ||
        ""
    ).trim();
    return v === MODE_CPU ? MODE_CPU : MODE_MULTIPLAYER;
  } catch {
    return MODE_MULTIPLAYER;
  }
}

export function setSelectedGameMode(mode) {
  const value = mode === MODE_CPU ? MODE_CPU : MODE_MULTIPLAYER;
  try {
    sessionStorage.setItem(MODE_STORAGE_KEY, value);
    localStorage.setItem(MODE_STORAGE_KEY, value);
  } catch {
    // ignore
  }
}

export function isCpuModeSelected() {
  return getSelectedGameMode() === MODE_CPU;
}

function readJson(key, fallback) {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore
  }
}

export function loadCpuSeries() {
  return readJson(CPU_SERIES_KEY, null);
}

export function saveCpuSeries(series) {
  writeJson(CPU_SERIES_KEY, series);
}

export function loadCpuGame() {
  return readJson(CPU_GAME_KEY, null);
}

export function saveCpuGame(state) {
  writeJson(CPU_GAME_KEY, state);
}

export function clearCpuSession() {
  try {
    sessionStorage.removeItem(CPU_SERIES_KEY);
    sessionStorage.removeItem(CPU_GAME_KEY);
  } catch {
    // ignore
  }
}

export function createCpuGameState(userId, playerName, series = null) {
  const fresh = createInitialConnect4State({
    player1UserId: String(userId ?? ""),
    player2UserId: CPU_OPPONENT_ID,
    mode: GAME_MODE.CPU,
    cpuPlayer: 2,
  });
  if (series) {
    fresh.player1Wins = Number(series.player1Wins) || 0;
    fresh.player2Wins = Number(series.player2Wins) || 0;
  }
  return fresh;
}

export function syncCpuSeriesAfterRound(roundState, playerName) {
  const existing = loadCpuSeries();
  const next = buildLeaderboardAfterRound(existing, roundState, {
    player1Name: String(playerName || existing?.player1Name || "You"),
    player2Name: "Computer",
  });
  next.player1UserId = String(roundState?.player1UserId ?? "");
  next.player2UserId = CPU_OPPONENT_ID;
  saveCpuSeries(next);
  return next;
}

export function startFreshCpuGame(userId, playerName) {
  const series = loadCpuSeries();
  const game = createCpuGameState(userId, playerName, series);
  saveCpuGame(game);
  return game;
}
